import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { WalletService } from '../services/wallet.service';

// Functional route guard that ensures a connected wallet
export const loginGuard: CanActivateFn = async () => {
  const wallet = inject(WalletService);
  const router = inject(Router);

  // If already connected, allow
  if (wallet.walletConnection()) {
    return true;
  }

  // Try to restore a previous connection quickly
  try {
    await wallet.restoreWalletConnection();
  } catch {
    // ignore
  }

  // Re-check after restore
  if (wallet.walletConnection()) {
    return true;
  }

  // Redirect to login when not connected
  return router.createUrlTree(['/login']);
};
